import ApiContext from 'api/ApiContext';
import { OverviewPollDay } from 'api/api.types';
import { useContext, useMemo } from 'react';
import { useQuery } from 'react-query';

const getAllElectionsOfType = (type: string, allPolls: OverviewPollDay[]) => {
  if (!allPolls) {
    return [];
  }
  return (
    allPolls
      .flatMap(({ issues }) => issues)
      .filter((issue) => issue.type === type)
      // sort by date in descending order, latest election first
      .sort((a, b) => {
        if (a.date < b.date) {
          return 1;
        }
        if (a.date > b.date) {
          return -1;
        }
        return 0;
      })
  );
};

const useGetPreviousElectionId = (previousIssueId: string, id: string, type: string) => {
  const { getPollDays } = useContext(ApiContext);
  const query = useQuery(['polling_days'], getPollDays);
  if (previousIssueId) {
    return previousIssueId;
  }
  const allPolls = query?.data?.data;
  const allElectionsOfType = useMemo(
    () => getAllElectionsOfType(type, allPolls),
    [allPolls, type],
  );
  const indexOfCurrentElection = allElectionsOfType.findIndex(
    (election) => election?.id === id,
  );
  const previousElection = allElectionsOfType[indexOfCurrentElection + 1];

  return previousElection?.id;
};

export default useGetPreviousElectionId;
